import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import ZhihuSquareFilledSvg from "@ant-design/icons-svg/es/asn/ZhihuSquareFilled";
import AntdIcon from "../components/AntdIcon";
var ZhihuSquareFilled = function ZhihuSquareFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ZhihuSquareFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  ZhihuSquareFilled.displayName = 'ZhihuSquareFilled';
}
export default /*#__PURE__*/React.forwardRef(ZhihuSquareFilled);